import { AxiosResponse } from 'axios'

import { apiByEntity } from './'

export const downloadEntityFile = (entity: string, entityId: string|number, fileKey: string) => {
  const api = getApiForEntity(entity)
  const entityEndpoint = getEndpointByEntity(entity)

  /**
   * This is a special handling for invoice. For some reason, the apparently same code for download works well for accidents/employees,etc with
   * format {id}/{filename} doesn't work for invoice, so we are removing the entityId for invoices only
   */
  if (entity === 'invoice') {
    // Remove the id path and leaves just the file name
    fileKey = fileKey.replace(`${entityId}/`,'')
  }

  return api.get(`/${entityEndpoint}/${entityId}/files/${fileKey}`)
    .then((response: AxiosResponse) => response.data)
}

export const deleteEntityFile = (entity: string, entityId: string|number, fileKey: string) => {
  const api = getApiForEntity(entity)
  const entityEndpoint = getEndpointByEntity(entity)

  return api.delete(`/${entityEndpoint}/${entityId}/files/${fileKey}`)
    .then((response: AxiosResponse) => response.data)
}

const getEndpointByEntity = (entity: string): string => {
  let entityEndpoint = entity
  if (entity === 'application') {
    entityEndpoint = `application/admin`
  }
  else if (entity === 'qaCheck') {
    entityEndpoint = 'qa-check'
  }

  return entityEndpoint
}

const getApiForEntity = (entity: string): any => {
  const api = apiByEntity[entity]

  if (api) {
    return api
  }

  throw new Error('No API mapped for this entity')
}



// WEBPACK FOOTER //
// ./src/lib/api/files.ts